import theme from '@styles/theme';
export default {
  title: {
    fontFamily: theme.fonts.uniformExtra,
    fontWeight: theme.fontWeights.normal,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    lineHeight: '110%',
    color: theme.rawColors.darkGrey700,
    fontSize: [theme.fontSizes.h2,
    // mobile - 32px
    theme.fontSizes.h2,
    // mobilelg - 32px
    theme.fontSizes.h2,
    // tablet - 32px
    theme.fontSizes.h2,
    // tabletlg - 32px
    theme.fontSizes.h2,
    // desktop - 32px
    theme.fontSizes.h1 // widescreen - 40px
    ],
    margin: 0,
    whiteSpace: ['normal', 'normal', 'nowrap', 'nowrap', 'nowrap', 'nowrap']
  }
};